module.exports = __webpack_public_path__ + "img/company-logo.ea7cc64a.svg";